import { VStack } from '@chakra-ui/react'
import React, { FC } from 'react'

import { CartListProps } from '../../types'
import CartListItem from './CartListItem'

const CartList: FC<CartListProps> = ({ items }) => {
  return (
    <VStack
      spacing={4}
      overflowY='auto'
      height='50vh'
      px={4}
      py={8}
      borderRadius='lg'
      shadow='md'
      backgroundColor='gray.100'
    >
      {items.map((item) => (
        <CartListItem key={item.key} item={item} />
      ))}
    </VStack>
  )
}

export default CartList
